import { Injectable, inject } from '@angular/core';
import { ClubHubDataService } from './clubhub-data.service';
import { FloorRateViewModel } from '@shared/models/floor-rate';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FloorRatesService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  public getFloorRatesByLenderId(lenderId: number): Observable<FloorRateViewModel> {
    return this.clubHubDataService.get(`FloorRates/lender/${lenderId}`);
  }

  public getFloorRatesByLenderNameId(lenderNameId: number): Observable<FloorRateViewModel[]> {
    return this.clubHubDataService.get(`FloorRates/lendername/${lenderNameId}`);
  }

  public updateFloorRates(floorRatesList: FloorRateViewModel[]): Observable<void> {
    return this.clubHubDataService.post('FloorRates', floorRatesList);
  }
}
